import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз ТЭП60 0121';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Серия ТЭП60 №0121</p>
                    <p>Построен в 1965 году на Коломенском тепловозостроительном заводе</p>
                    <p>Тип - пассажирский, односекционный, с двумя кабинами машиниста</p>
                    <p>Конструктивная скорость - 160 км/ч</p>
                    <p>Служебный вес - 126т</p>
                    <p>Нагрузка на ось - 21т</p>
                    <p>Мощность - 3000 л.с.</p>
                    <p>Двухсекционный ТЭП60 для тяжёлых профилей и поездов. Экономичность такого локомотива была низкой, но в связи с задержкой выпуска более мощных пассажирских тепловозов пришлось выпускать и использовать эти.</p>
                    <ul>
                        <li>годы выпуска 1964, 1966, 1968, 1972 - 1985, 1987</li>
                        <li>построено 116</li>
                        <li>изготовитель - Коломенский завод</li>
                        <li>дизели: 11Д45 (2 х 3000 л.с.)</li>
                    </ul>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt052.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt053.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt054.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt055.jpg')} /></div>
            </div>
        </>
    );
}